import Vue from 'vue';

export default {
    SET_USER (state, payload) {
        state.user = payload;
        window.localStorage.setItem('user', JSON.stringify(state.user));
    },
    UPDATE_USER (state, payload) {
        state.user = Object.assign({}, state.user, payload);
        window.localStorage.setItem('user', JSON.stringify(state.user));
    },
    UPDATE_ACTIVE_STORE (state, payload) {
        state.activeStore = payload;
        window.localStorage.setItem('activeStore', JSON.stringify(state.activeStore));
    },
    SET_ACTIVE_STORE_BUSINESS_HOURS (state, payload) {
        if (state.activeStore) {
            Vue.set(state.activeStore, 'businessHours', payload);
        }
    },
    SET_ACTIVE_STORE_PUBLIC_HOLIDAYS (state, payload) {
        if (state.activeStore) {
            Vue.set(state.activeStore, 'publicHolidays', payload);
        }
    },
    UPDATE_ACTIVE_STORE_BUSINESS_HOURS (state, payload) {
        Vue.set(state.activeStore.businessHours[payload.index], payload.key, payload.value);
    },
    UPDATE_ACTIVE_STORE_PUBLIC_HOLIDAYS (state, payload) {
        Vue.set(state.activeStore.publicHolidays[payload.index], payload.key, payload.value);
    },
    ADD_ACTIVE_STORE_PUBLIC_HOLIDAY (state, payload) {
        state.activeStore.publicHolidays.push(payload);
    },
    DELETE_ACTIVE_STORE_PUBLIC_HOLIDAY (state, payload) {
        state.activeStore.publicHolidays.splice(payload, 1);
    },
    REMOVE_DELETED_PUBLIC_HOLIDAYS (state) {
        Vue.set(state.activeStore, 'publicHolidays', state.activeStore.publicHolidays.filter(p => p.delete !== true));
    },
    ADD_ACTIVE_STORE_BREAK (state, payload) {
        state.activeStore.businessHours[payload.businessHourIndex].breaks.push(payload.value);
    },
    DELETE_ACTIVE_STORE_BREAK (state, payload) {
        state.activeStore.businessHours[payload.businessHourIndex].breaks.splice(payload.index, 1);
    },
    UPDATE_ACTIVE_STORE_BREAK_ATTRIBUTE (state, payload) {
        Vue.set(state.activeStore.businessHours[payload.businessHourIndex].breaks[payload.index], payload.key, payload.value);
    },
    UPDATE_LANGUAGE (state, payload) {
        state.language = payload;
    },
    UPDATE_BASE_URL (state, payload) {
        state.baseUrl = payload;
    },
    SET_LAST_ROUTE (state, payload) {
        state.lastRoute = payload;
    },
    SET_IS_ROUTER_BUSY (state, payload) {
        state.isRouterBusy = payload;
    },
    SET_BUSY (state, payload) {
        state.busy = payload;
    },
    SET_NOTIFICATION_COUNT (state, payload) {
        state.notificationCount = payload;
    },
    SET_PAGINATION_STATE (state, payload) {
        state.currentPageState.name = payload.name;
        state.currentPageState.current = payload.current;
        state.currentPageState.type = payload.type;
    },
    SET_MENU_ITEMS (state, payload) {
        state.menuItems = payload;
    },
    SET_CURRENT_ROUTE (state, payload) {
        state.currentRoute = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/bmr/mutations.js